module.exports = __webpack_public_path__ + "media/common/images/dashboard/calendar-a30eb0f2168be8a02497f40f12dbf73f.svg";